// Silly, animated, over-the-top Phaser 3 "Game Won" scene
export class GameLostScene extends Phaser.Scene {
  constructor() {
    super("GameLostScene");
  }

  preload() {
    this.load.image(
      "confetti",
      "https://labs.phaser.io/assets/particles/yellow.png",
    );
    this.load.image("clown", "https://labs.phaser.io/assets/sprites/clown.png");
    this.load.audio(
      "victory",
      "https://labs.phaser.io/assets/audio/SoundEffects/p-ping.mp3",
    );
    this.load.spritesheet(
      "dancer",
      "https://labs.phaser.io/assets/sprites/chick.png",
      {
        frameWidth: 64,
        frameHeight: 64,
      },
    );
  }

  create() {
    this.sound.play("victory");

    // Silly background color flash
    this.cameras.main.setBackgroundColor("#ff69b4");
    this.time.addEvent({
      delay: 300,
      callback: () => {
        const colors = ["#ff69b4", "#ffff00", "#00ffff", "#ff00ff"];
        this.cameras.main.setBackgroundColor(
          Phaser.Utils.Array.GetRandom(colors),
        );
      },
      loop: true,
    });

    // Text Explosion
    const text = this.add
      .text(window.innerWidth / 2, 400, "YOU WON!", {
        fontSize: "100px",
        fontFamily: "Comic Sans MS",
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 10,
      })
      .setOrigin(0.5);
    this.tweens.add({
      targets: text,
      scale: { from: 0.5, to: 2 },
      yoyo: true,
      repeat: -1,
      ease: "Bounce.easeInOut",
      duration: 1000,
    });

    this.add.particles(0, 0, "confetti", {
      x: { min: 0, max: window.innerWidth },
      y: 0,
      lifespan: 4000,
      speedY: { min: 200, max: 400 },
      scale: { start: 0.5, end: 0 },
      quantity: 10,
      blendMode: "ADD",
    });

    // Clown that flies across screen every 2 seconds
    this.time.addEvent({
      delay: 2000,
      callback: () => {
        const clown = this.add.image(
          -100,
          Phaser.Math.Between(100, 500),
          "clown",
        );
        this.tweens.add({
          targets: clown,
          x: 900,
          duration: 3000,
          ease: "Cubic.easeInOut",
          onComplete: () => clown.destroy(),
        });
      },
      loop: true,
    });

    // Dancing sprite
    this.anims.create({
      key: "dance",
      frames: this.anims.generateFrameNumbers("dancer", { start: 0, end: 3 }),
      frameRate: 6,
      repeat: -1,
    });
    // const dancer = this.add.sprite(400, 300, "dancer").play("dance");
    // this.tweens.add({
    //   targets: dancer,
    //   angle: { from: -20, to: 20 },
    //   yoyo: true,
    //   repeat: -1,
    //   duration: 400,
    // });
    this.sound.stopAll();
    this.sound.add("win", { volume: 1 }).play();
  }
}
